import {Login_URL} from "../config/constants";

export const isMoreThanOneHourPassed = () => {
    const storedSessionStartTime = localStorage.getItem("sessionTimeout");
    const isLoginPath = location.pathname === Login_URL
    const oneHour = 60 * 60 * 1000
    const now = Date.now()

    if (isLoginPath) {
        return false;
    }

    if (!storedSessionStartTime) {
        localStorage.setItem("sessionTimeout", now);
        return false;
    }

    const sessionStartTime = Number(storedSessionStartTime)

    const diffInMs = now - sessionStartTime;

    const isDateExpired = diffInMs > oneHour

    if (!isDateExpired) {
        localStorage.setItem("sessionTimeout", now);
        return false;
    }

    localStorage.setItem("logout", now); // trigger event for multi tabs open
    return true;
}